export default function Footer() {
  return (
    <footer className="bg-[#1B3A2F] text-white pt-16 pb-8 relative overflow-hidden">
      {/* Bannière Offre Prévente */}
      <div className="bg-gradient-to-r from-[#E8956F] to-[#D67D5A] py-8 mb-12">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-1.5 rounded-full mb-4">
            <i className="ri-time-line text-white text-sm"></i>
            <span className="text-xs font-medium text-white uppercase tracking-wider">Offre Limitée</span>
          </div>
          
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Offre de Prévente Exceptionnelle
          </h3>
          
          <div className="flex items-center justify-center gap-4 mb-4">
            <span className="text-2xl md:text-3xl font-bold text-white line-through opacity-70">597€</span>
            <span className="text-5xl md:text-6xl font-extrabold text-white">297€</span>
          </div>
          
          <p className="text-base md:text-lg text-white/95 mb-6 max-w-2xl mx-auto">
            Profitez de <strong>50% de réduction</strong> jusqu'au <strong>jeudi 18 décembre</strong>
          </p>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 mb-6 max-w-md mx-auto">
            <div className="flex items-center justify-center gap-3 mb-2">
              <i className="ri-calendar-check-line text-white text-xl"></i>
              <span className="text-lg font-semibold text-white">Début de la formation</span>
            </div>
            <p className="text-2xl font-bold text-white mb-3">22 décembre 2025</p>
            <div className="flex items-center justify-center gap-2 text-white/90">
              <i className="ri-time-line text-base"></i>
              <span className="text-sm font-medium">Durée : 4 semaines</span>
            </div>
          </div>
          
          <a 
            href="https://sophrocavaliers.learnybox.com/formation-endometriose-cavalieres/"
            target="_blank"
            rel="noopener noreferrer"
            className="px-10 py-4 bg-[#1A1A1A] text-white rounded-full text-base font-bold hover:bg-black transition-all shadow-2xl hover:shadow-3xl hover:-translate-y-1 whitespace-nowrap cursor-pointer"
          >
            Réserver ma place à 297€ <i className="ri-arrow-right-line ml-2"></i>
          </a>
          
          <p className="text-xs text-white/80 mt-4">
            Places limitées • Paiement sécurisé
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6">
        {/* Structure 4 colonnes */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16 relative z-10">
          {/* Colonne 1 - Identité */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Sophro Cavaliers
            </h3>
            <p className="text-sm text-[#B8C4BF] leading-relaxed" style={{ lineHeight: '1.6' }}>
              Formation spécialisée en sophrologie pour cavalières atteintes d'endométriose. Reprenez votre liberté à cheval.
            </p>
          </div>

          {/* Colonne 2 - Newsletter */}
          <div>
            <h4 className="text-xs uppercase text-[#B8C4BF] mb-4 tracking-wider">NEWSLETTER</h4>
            <p className="text-sm text-white mb-4">
              Recevez nos conseils et actualités
            </p>
            <div className="relative">
              <input 
                type="email" 
                placeholder="Votre email"
                className="w-full bg-transparent border-b border-[#B8C4BF]/30 pb-2 text-sm text-white placeholder-[#B8C4BF]/60 focus:outline-none focus:border-[#E8956F] transition-colors"
              />
              <button className="absolute right-0 bottom-2 text-[#E8956F] hover:text-white transition-colors cursor-pointer">
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </div>
          </div>

          {/* Colonne 3 - Navigation */}
          <div>
            <h4 className="text-xs uppercase text-[#B8C4BF] mb-4 tracking-wider">FORMATION</h4>
            <nav className="space-y-5">
              <a href="#solution" className="block text-sm text-white hover:text-[#E8956F] transition-colors cursor-pointer">Découvrir</a>
              <a href="#benefices" className="block text-sm text-white hover:text-[#E8956F] transition-colors cursor-pointer">Avantages</a>
            </nav>
          </div>

          {/* Colonne 4 - Social */}
          <div>
            <h4 className="text-xs uppercase text-[#B8C4BF] mb-4 tracking-wider">SUIVEZ-NOUS</h4>
            <nav className="space-y-5">
              <a href="https://www.instagram.com/sophro.cavaliers?igsh=MXB3Z2piZHJqYWpzbQ==" target="_blank" rel="noopener noreferrer" className="block text-sm text-white hover:text-[#E8956F] transition-colors cursor-pointer">Instagram</a>
              <a href="https://www.facebook.com/share/14QEDSpqefY/" target="_blank" rel="noopener noreferrer" className="block text-sm text-white hover:text-[#E8956F] transition-colors cursor-pointer">Facebook</a>
            </nav>
          </div>
        </div>

        {/* Bas footer - Typographie large */}
        <div className="relative h-32 md:h-40 flex items-center justify-center overflow-hidden">
          <div className="text-6xl md:text-8xl lg:text-9xl font-bold text-[#E8DDD4]/20 tracking-tighter whitespace-nowrap" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            SOPHRO CAVALIERS
          </div>
        </div>

        {/* Copyright et lien Readdy */}
        <div className="border-t border-[#B8C4BF]/20 pt-6 mt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-[#B8C4BF]">
          <p>&copy; 2025 Sophro Cavaliers. Tous droits réservés.</p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-white transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}